import { render, staticRenderFns } from "./ModalDatosClienteEdit.vue?vue&type=template&id=23815d90&scoped=true"
import script from "./ModalDatosClienteEdit.vue?vue&type=script&lang=js"
export * from "./ModalDatosClienteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23815d90",
  null
  
)

export default component.exports